import {IActiveFilter, DispatchFunction, IFilterSelect, VaultPasswordExpireReason} from '@app/models';
import { addActiveFilter } from '@app/store/actions';
import { Dispatch } from 'redux';

export function saveActiveFilter(value: string, name: string, label: string, filterBy?: string ): DispatchFunction {
    const filterToAdd: IActiveFilter = {
        name: name,
        value: value,
        label: label
    };

    if (!!filterBy) {
        filterToAdd.filterBy = filterBy;
    }
    return ((dispatch: Dispatch) => dispatch(addActiveFilter(filterToAdd)));
}

export const provisionStateSelectData: IFilterSelect[] = [
    {
        id: 0,
        label: 'PROVISION_STATE_ACTIVE',
        value: 'Active'
    },
    {
        id: 1,
        label: 'PROVISION_STATE_CREATED',
        value: 'Created'
    },
    {
        id: 2,
        label: 'PROVISION_STATE_INACTIVE',
        value: 'Disabled'
    },
    {
        id: 3,
        label: 'PROVISION_STATE_EVERYTHING',
        value: 'Everything'
    },
    {
        id: 4,
        label: 'PROVISION_STATE_PROVISIONED',
        value: 'Provisioned'
    },
];

export const confirmQuestionData: IFilterSelect[] = [
    {
        id: 0,
        label: 'YES',
        value: 'Yes'
    },
    {
        id: 1,
        label: 'NO',
        value: 'No'
    }
];

export const trueFalseQuestionData: IFilterSelect[] = [
    {
        id: 0,
        label: 'YES',
        value: 'true'
    },
    {
        id: 1,
        label: 'NO',
        value: 'false'
    }
];

export const expirationReasonData: IFilterSelect[] = [
    {
        id: 0,
        label: 'EXPIRED',
        value: VaultPasswordExpireReason.Expired
    },
    {
        id: 1,
        label: 'REVEALED',
        value: VaultPasswordExpireReason.Revealed
    },
    {
        id: 1,
        label: 'COMPROMISED',
        value: VaultPasswordExpireReason.Compromised
    }
];

export const jitStatusData: IFilterSelect[] = [
    {
        id: 0,
        label: 'JIT_AVAILABLE',
        value: 'Available'
    },
    {
        id: 1,
        label: 'JIT_IN_USE',
        value: 'In Use'
    }
];
